import { IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { MfaType } from '../../enums/auth';

export class MfaSetupRequestDto {
    @IsNotEmpty()
    @IsEnum(MfaType)
    type: MfaType;

    @IsOptional()
    @IsString()
    identifier?: string;
}
